import service from '@/utils/index'


// 登录 - 手机登录发送验证码
const login_send_sms = params => {
  return service.get('auth/login_send_sms', { params: params })
}
/* 登录 */
const complex_login = params => {
  const data = params
  data.mac = params.mac ? params.mac : '1222'
  return service.post('auth/complex_login', params)
}
/* 微信登录 */
const getQrcode = params => {
  return service.get('auth/website_get_qrcode_url', { params: params })
}
/* qq登录 */
const getQrcodeByqq = params => {
  return service.get('/auth/website_get_qqlogin_url', params)
}
// 登录 - 手机号登录设置密码
const set_password = params => {
  return service.post('auth/set_password', params)
}
// 消费列表 - 获取我的消费列表
const get_my_orderlist = params => {
  return service.get('order/get_my_orderlist', { params: params })
}
// 忘记密码-验证短信验证码
const reset_password_confirm_sms = params => {
  return service.post('auth/reset_password_confirm_sms', params)
}
// 忘记密码 - 重置密码
const reset_password = params => {
  return service.post('auth/reset_password', params)
}

const rest_password_send_sms = params => {
  return service.get('auth/rest_password_send_sms', { params: params })
}
// 获取个人信息
const get_my_info = params => {
  return service.get('customer/get_my_info', { params: params })
}
// 修改个人信息
const change_myinfo = params => {
  return service.post('customer/change_myinfo', params)
}
// 登录 - 绑定手机号发送验证码
const bind_mobile_send_sms = params => {
  return service.get('auth/bind_mobile_send_sms', { params: params })
}
// 登录 - 绑定手机号
const bind_mobile = params => {
  return service.post('auth/bind_mobile', params)
}
// 登录 - 绑定手机号设置密码
const bind_mobile_set_password = params => {
  return service.post('auth/bind_mobile_set_password', params)
}

/* 退出登录 */
const logoutApi = params => {
  return service.get('auth/logout', params)
}
/* 获取机房列表 */
const get_server_room_list = () => {
  return service.get('auth/get_server_room_list')
}
// 获取产品列表
const get_products = params => {
  return service.get('auth/get_products', { params })
}
/* 放弃连接 */
const cancel_order = params => {
  return service.get('/queue/cancel_order', { params })
}
/* 确认连接 */
const confirm_order = params => {
  return service.get('/queue/confirm_order', { params })
}

// 获取活动弹窗
const get_popupad_list = params => {
  return service.get('/popupad/list', { params })
}

// 设置个人默认机房
const set_server_room = params => {
  return service.post('/customer/set_server_room', params)
}

// 获取游戏分类
const get_category_list = () => {
  return service.get('/gamecategory/list')
}
// 获取全部游戏列表
const get_games = params => {
  return service.get('/game/list', { params })
}
const orderStatus = params => {
  return service.get('order/get_order_status', { params: params })
}
/* 价格列表 */
const price_list = params => {
  return service.get('/goodsCurrency/getGoodsCurrencyList', params)
}
/* 支付 */
const pay_info = params => {
  return service.post('/recharge/zqbPayCurrency', params)
}

/* 预付款状态 */
const getRechargeStatus = params => {
  return service.get(`/recharge/pcGetRechargeStatus?payId=${params.id}`)
}

// 绑定微信- 解绑
const release_wx = params => {
  return service.get('customer/release_wx', { params: params })
}
// 绑定微信- 获取二维码地址
const bind_get_wx_qrcode = params => {
  return service.get('customer/website_bind_get_wx_qrcode', { params: params })
}
// 绑定微信- 绑定
const bind_wx = params => {
  return service.post('customer/website_bind_wx', params)
}

// 绑定QQ- 获取二维码地址
const bind_get_qq_qrcode = params => {
  return service.get('customer/website_bind_get_qq_qrcode')
}
// 绑定QQ-绑定
const bind_qq = params => {
  return service.post('customer/website_bind_qq', params)
}
// 绑定QQ- 解绑
const release_qq = params => {
  return service.get('customer/release_qq', { params: params })
}

// 创建订单
const begin_order = params => {
  return service.post('order/begin_order', params)
}
const video_list = params => {
  return service.get('/baseData/getVideoList', { params })
}
// 获取充值列表
const rechargeList = params => {
  return service.get('recharge/list', { params: params })
}
const sumbit_collected_issue = params => {
  return service.post('collectedproblem/add', params)
}
const finishOrder = params => {
  return service.post('order/finish_order', params)
}
// 获取单个游戏信息
const get_game = ({ id }) => {
  return service.get(`/game/get/${id}`)
}
// 变更手机号码-旧手机发送验证码
const send_sms_old_mobile = params => {
  return service.get('customer/send_sms_old_mobile', { params: params })
}
// 变更手机号 - 老手机号验证
const auth_old_mobile = params => {
  return service.post('customer/auth_old_mobile', params)
}
// 变更手机号 - 新手机号发送验证码
const send_sms_new_mobile = params => {
  return service.get('customer/send_sms_new_mobile', { params: params })
}
// 变更手机号 - 变更手机号
const change_mobile = params => {
  return service.post('customer/change_mobile', params)
}
// 获取是否第一次注册
const validate_mobile = params => {
  return service.get('auth/validate_mobile',  { params: params })
}
const cancel_queue = () => {
  return service.get('/queue/cancelQueue')
}
/* 获取平台信息 */
const platform_info = () => {
  return service.get('/gamePlatform/list')
}
/* 获取平台绑定的账户信息列表接口 */
const platform_account = params => {
  return service.get('/gamePlatform/getAccountById', { params: params })
}
/* 修改平台绑定的默认账户接口 */
const update_account = params  =>{
  return service.post('/gamePlatform/updateDefaultAccount', params)
}
/* 绑定中青宝通行证账户接口 */
const bind_account = params  =>{
  return service.post('/gamePlatform/bindZqbAccount', params)
}
/* 修改备注名称接口 */
const confirm_account = params  =>{
  return service.post('/gamePlatform/updateRemark', params)
}
/* 删除中青宝通行证账户接口 */
const delete_account = params => {
  return service.get('/gamePlatform/deleteAccount', { params: params })
}
/* 获取下载地址 */
const downLoad = () =>{
  return service.get('/clientversion/get_latest_version')
}
export default {
  login_send_sms,
  complex_login,
  getQrcode,
  getQrcodeByqq,
  get_my_orderlist,
  logoutApi,
  reset_password_confirm_sms,
  rest_password_send_sms,
  set_password,
  change_myinfo,
  get_my_info,
  get_server_room_list,
  get_products,
  cancel_order,
  confirm_order,
  get_popupad_list,
  set_server_room,
  get_category_list,
  get_games,
  orderStatus,
  bind_mobile_send_sms,
  bind_mobile,
  bind_mobile_set_password,
  reset_password,
  price_list,
  pay_info,
  getRechargeStatus,
  release_wx,
  bind_get_wx_qrcode,
  bind_wx,
  bind_get_qq_qrcode,
  bind_qq,
  release_qq,
  begin_order,
  video_list,
  rechargeList,
  sumbit_collected_issue,
  finishOrder,
  get_game,
  send_sms_old_mobile,
  auth_old_mobile,
  send_sms_new_mobile,
  change_mobile,
  validate_mobile,
  cancel_queue,
  platform_info,
  platform_account,
  update_account,
  bind_account,
  confirm_account,
  delete_account,
  downLoad
}